export function readStepByStepGuidesFromLocalStorage() {
  const lsData = localStorage.getItem('step_by_step_guides');
  return lsData ? JSON.parse(lsData) : [];
}
